import { TableCell } from "@mui/material"
import { CheckBoxCheckedIcon, CheckBoxUncheckedIcon } from "@assets/icons"
import TableRow from "@mui/material/TableRow"
import styles from "./PrescribedExercisesTable.module.css"
import { DeleteIcon, PenIcon } from "@assets/icons"
import { Checkbox } from "@mui/material"
import { MinusCircleIcon } from "@assets/icons"
import { AddCircleIcon } from "@assets/icons/AddCircle"
import ArrowRightInsideCircle from "@assets/icons/arrowRightInsideCircle"
import { Button } from "@components/Button"
import { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { EditOpacity } from "../EditOpacity"
import useExercise from "@hooks/useExercise"
import usePatient from "@hooks/usePatient"
import { useSelector } from "react-redux"
import { exercisesList } from "./helper"

const PrescribedExercisesTableRow = ({
  exercise,
  patientData,
  editableRows,
  setEditableRows,
  setSelectedExercisesToDelete,
  setSelectedExerciseToDelete,
  setShowDeletePrescribedExercise,
  path,
  exerciseLookup,
  paginationState
}) => {
  const [exerciseDetails, setExerciseDetails] = useState(
    initializeExerciseDetails
  )
  useEffect(() => {
    const details = initializeExerciseDetails;
    setExerciseDetails(details);
  }, [path, paginationState]);
  const { isUpdateExerciseOtlLoading } = useSelector((state) => {
    return state.exercise
  })
  const { handleGetSinglePatient } = usePatient()
  const { handleUpdateExerciseOtl } = useExercise()
  const [searchParams] = useSearchParams()
  const patientId = searchParams.get("_id")
  const [showEditOpacity, setShowEditOpacity] = useState(false)
  const isEditable =
    editableRows && editableRows[exercise.exerciseName] === "yes"
  const tableBodyCellStyles = {
    color: "var(--quaternary-black)",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "16px",
    padding: "0px",
    height: "42px",
    "@media (max-width:823px)": {
      minWidth: "150px",
    },
    minWidth: "250px",
  }

  function initializeExerciseDetails() {
    if (exercise) {
      if (path === "vr") {
        let modifiedExerciseName = exercise.exerciseName.replace(/_.*/, '')
        return {
          exerciseName: exercise.exerciseName,
          level: patientData.exercises[path][modifiedExerciseName].level || patientData.exercises[path].level,
          time: patientData.exercises[path][modifiedExerciseName].time || patientData.exercises[path].time,
        }
      } else {
        let time = exercise.time ? exercise.time : patientData.exercises[path].time
        let level = exercise.level ? exercise.level: patientData.exercises[path].level
        let opacity1 = exercise.opacity1 ? Math.floor(parseFloat(exercise?.opacity1?.$numberDecimal) * 100) : Math.floor(parseFloat(patientData?.exercises[path]?.opacity1?.$numberDecimal) * 100)
        let opacity2 = exercise.opacity2 ? Math.floor(parseFloat(exercise.opacity2?.$numberDecimal) * 100) : Math.floor(parseFloat(patientData?.exercises[path]?.opacity2?.$numberDecimal) * 100)
        return {
          exerciseName: exercise.exerciseName,
          level: level,
          time: time,
          opacity1: opacity1,
          opacity2: opacity2
        }
      }
    }
    return {}
  }

  const timePlusButtonClickHandler = () => {
    if (isEditable) {
      setExerciseDetails((previous) => {
        const time = Math.min(10, previous.time + 1)
        return { ...previous, time }
      })
    }
  }

  const timeMinusButtonClickHandler = () => {
    if (isEditable) {
      setExerciseDetails((previous) => {
        const time = Math.max(1, previous.time - 1)
        return { ...previous, time }
      })
    }
  }

  const levelPlusButtonClickHandler = () => {
    if (isEditable) {
      setExerciseDetails((previous) => {
        const level = Math.min(6, previous.level + 1)
        return { ...previous, level }
      })
    }
  }

  const levelMinusButtonClickHandler = () => {
    if (isEditable) {
      setExerciseDetails((previous) => {
        const level = Math.max(1, previous.level - 1)
        return { ...previous, level }
      })
    }
  }
  const closeEditOpacity = () => {
    setShowEditOpacity(false)
  }

  const updateOpacities = (opacities) => {
    setExerciseDetails((previous) => {
      return { ...previous, ...opacities }
    })
  }

  const getExerciseName = (code, path) => {
    return exerciseLookup[path]?.[code]?.name || "N/A";
  }

  const UpdateExerciseOtlSuccess = () => {
    handleGetSinglePatient({ _id: patientId })
    setEditableRows((previous) => {
      return { ...previous, [exercise.exerciseName]: "no" }
    })
  }
  return (
    <>
      {showEditOpacity && isEditable ? (
        <EditOpacity
          onClose={closeEditOpacity}
          onApply={updateOpacities}
          initialOpacities={exerciseDetails}
        />
      ) : null}
      <TableRow key={exercise.exerciseName}>
        <TableCell
          align="left"
          sx={{
            ...tableBodyCellStyles,
            width: "72px",
            minWidth: "unset !important",
          }}
        >
          <div className={styles.exerciseCheckBox}>
            <Checkbox
              onChange={(event) => {
                if (event.target.checked) {
                  setSelectedExercisesToDelete((previous) => {
                    const newSet = new Set(previous)
                    newSet.add(event.target.value)
                    return newSet
                  })
                } else {
                  setSelectedExercisesToDelete((previous) => {
                    const newSet = new Set(previous)
                    newSet.delete(event.target.value)
                    return newSet
                  })
                }
              }}
              value={exercise.exerciseName}
              icon={<CheckBoxUncheckedIcon className={"text-[#D0D5DD]"} />}
              checkedIcon={
                <CheckBoxCheckedIcon
                  fill="var(--primary-blue)"
                  stroke="var(--pure-white)"
                />
              }
            />
          </div>
        </TableCell>
        <TableCell component="th" scope="row" sx={tableBodyCellStyles}>
          <div className={styles.tableCellContent}>{ getExerciseName(exercise.exerciseName, path)}</div>
        </TableCell>
        <TableCell align="left" sx={tableBodyCellStyles}>
          <div className={styles.tableCellContent}>
            {isEditable ? (
              <div className="flex items-center gap-4 justify-between px-2">
                <button onClick={timeMinusButtonClickHandler}>
                  <MinusCircleIcon className="text-[--primary-blue]" />
                </button>
                <div>{exerciseDetails.time} mins</div>
                <button onClick={timePlusButtonClickHandler}>
                  <AddCircleIcon className="text-[--primary-blue]" />
                </button>
              </div>
            ) : (
              <div>{exerciseDetails.time} mins</div>
            )}
          </div>
        </TableCell>
        <TableCell align="left" sx={tableBodyCellStyles}>
          <div className={styles.tableCellContent}>
            {isEditable ? (
              <div className="flex items-center gap-4 justify-between px-2">
                <button onClick={levelMinusButtonClickHandler}>
                  <MinusCircleIcon className="text-[--primary-blue]" />
                </button>
                <div>{exerciseDetails.level}</div>
                <button onClick={levelPlusButtonClickHandler}>
                  <AddCircleIcon className="text-[--primary-blue]" />
                </button>
              </div>
            ) : (
              <div>{exerciseDetails.level}</div>
            )}
          </div>
        </TableCell>
        {path !== "vr" && (
          <>
            <TableCell align="left" sx={tableBodyCellStyles}>
              <div className={styles.tableCellContent}>
                <div className="flex gap-5 items-center">
                  {exerciseDetails?.opacity1} %
                  {isEditable ? (
                    <button
                      onClick={() => {
                        if (isEditable) {
                          setShowEditOpacity(true)
                        }
                      }}
                    >
                      <ArrowRightInsideCircle
                        className={"h-[1rem] w-[1rem] text-[--primary-blue]"}
                      />
                    </button>
                  ) : null}
                </div>
              </div>
            </TableCell>
            <TableCell align="left" sx={tableBodyCellStyles}>
              <div className={styles.tableCellContent}>
                <div className="flex gap-5 items-center">
                  {exerciseDetails.opacity2} %
                  {isEditable ? (
                    <button
                      onClick={() => {
                        if (isEditable) {
                          setShowEditOpacity(true)
                        }
                      }}
                    >
                      <ArrowRightInsideCircle
                        className={"h-[1rem] w-[1rem] text-[--primary-blue]"}
                      />
                    </button>
                  ) : null}
                </div>
              </div>
            </TableCell>
          </>
        )}
        <TableCell
          align="left"
          sx={{
            ...tableBodyCellStyles,
            width: "72px",
            minWidth: "unset !important",
          }}
        >
          {isEditable ? (
            <div className="flex gap-2 justify-center">
              <Button
                loading={isUpdateExerciseOtlLoading}
                onClick={() => {
                  const updatedValues = {
                    patientId,
                    isVR: path === "vr",
                    exerciseName: exercise.exerciseName.replace(/_.*/, ''),
                  }
                  if (path !== "vr") {
                    if (exerciseDetails.opacity1 !== exercise.opacity1) {
                      updatedValues.opacity1 = exerciseDetails?.opacity1 / 100
                    }
                    if (exerciseDetails.opacity2 !== exercise.opacity2) {
                      updatedValues.opacity2 = exerciseDetails?.opacity2 / 100
                    }
                  }
                  if (exerciseDetails.time !== exercise.time) {
                    updatedValues.time = exerciseDetails.time
                  }
                  if (exerciseDetails.level !== exercise.level) {
                    updatedValues.level = exerciseDetails.level
                  }
                  handleUpdateExerciseOtl(
                    updatedValues,
                    UpdateExerciseOtlSuccess
                  )
                }}
                variant="primary"
                className="!px-2 !py-1 !h-max !text-xs"
              >
                save
              </Button>
            </div>
          ) : (
            <button
              onClick={() => {
                setEditableRows((previous) => {
                  return { ...previous, [exercise.exerciseName]: "yes" }
                })
              }}
              className={styles.editSideBarCell}
            >
              <PenIcon className="h-[1rem] w-[1rem] text-[--text-black-dark]" />
            </button>
          )}
        </TableCell>
        <TableCell
          align="left"
          sx={{
            ...tableBodyCellStyles,
            width: "72px",
            minWidth: "unset !important",
          }}
        >
          <button
            className={styles.editSideBarCell}
            onClick={() => {
              setShowDeletePrescribedExercise(true)
              setSelectedExerciseToDelete(() => {
                const newSet = new Set()
                newSet.add(exercise.exerciseName)
                // console.log(exercise.exerciseName)
                return newSet
              })
            }}
          >
            <DeleteIcon className="h-[1rem] w-[1rem] text-[--text-black-dark] stroke-[1.5px]" />
          </button>
        </TableCell>
      </TableRow>
    </>
  )
}

export default PrescribedExercisesTableRow
